var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-container-search-bar"},[_c('p',{staticClass:"v-text-searchbar font-weight-black "},[_vm._v(" "+_vm._s(_vm.nameScreen)+" ")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }